export default function ScanController(SearchConfig, ZebraService, $state) {
    var ctrl = this;

    ctrl.maximumTerms = SearchConfig.maximumTerms;

    ctrl.$onInit = function() {
        ctrl.callScan(ctrl.term);
    };

    ctrl.callScanNew = function(item) {
        console.log('callScanView', item);
        if (item && item.displayTerm) {
            $state.go('name', {name: item.displayTerm});
        }
    };

    ctrl.callScan =  function(term) {
        if (term) {
            ctrl.loading = true;
            scan(ctrl.catalogid, ctrl.index, term, 1, ctrl.maximumTerms,  function(err, response) {
                ctrl.loading = false;
                if (err) {
                    ctrl.error = err.message || err;
                }
                ctrl.response = response;
            });
        }
    };

    ctrl.callScanNext = function() {
        if (ctrl.response && ctrl.response.terms && ctrl.response.terms.length > 0) {
            var size = ctrl.response.terms.length;
            ctrl.loading = true;
            scan(ctrl.catalogid, ctrl.index, ctrl.response.terms[size-1].value, 1, ctrl.maximumTerms,  function(err, response) {
                ctrl.loading = false;
                if (err) {
                    ctrl.error = err.message || err;
                }
                ctrl.response = response;
            });
        }
    }
    ctrl.callScanPrev = function() {
        if (ctrl.response && ctrl.response.terms && ctrl.response.terms.length > 1) {
            var size = ctrl.response.terms.length;
            ctrl.loading = true;
            scan(ctrl.catalogid, ctrl.index, ctrl.response.terms[0].value, size, ctrl.maximumTerms,  function(err, response) {
                ctrl.loading = false;
                if (err) {
                    ctrl.error = err.message || err;
                }
                ctrl.response = response;
            });
        }
    }

    ////////

    function scan(id, index, term, pos, max, done) {
        var params = {};
        params.id = id;
        params.operation = 'scan';
        params.scanClause = index + '="^' + term.replace(/"/g, '\\"') +'"';
        params.maximumTerms = max;
        params.responsePosition = pos;
        console.log(term);
        ZebraService.get(params).$promise.then(function(response) {
            done(null, response);
        }, function(err) {
            done(err, null);
        });
    }

};
ScanController.$inject = ['SearchConfig', 'ZebraService', '$state'];
